import axios from "axios";

let digiApiUrlBase = 'https://api.kanalk.ch/v2/digi/';

/**
 * Current Song & Artist
 * @param wpPath
 * @returns {Promise<AxiosResponse<any>>}
 */
export function digiFetchCurrentSong() {
    return axios
        .get(digiApiUrlBase + 'current')
        .then(res => {
            if (typeof res.data !== "undefined") {
                return res.data
            }
            return false;
        });
}

/**
 * Last Played Twenty Songs (Song & Artist)
 * @returns {Promise<AxiosResponse<any>>}
 */
export function digiFetchPlaylist() {
    return axios
        .get(digiApiUrlBase + 'playlist')
        .then(res => {
            if (typeof res.data !== "undefined") {
                return res.data
            }
            return false;
        });
}
